import { AfterViewInit, ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import {
  CombosConfiguration,
  fileInputParams,
  HttpService,
  LocalStorageService,
  MessageService,
  params,
} from 'brainloper-ui';
import { EndpointDictionary } from 'app/utils/endpoints-dictionary';
import { Region } from 'app/models2/administration/region';
import { Country } from 'app/models2/administration/country';
import { ModalTypes } from 'app/models2/localization/modal-types';
import { GenericResponse } from 'app/models2/commos/generic-response';
import { UpdateData } from 'app/models2/commos/update-data';
import { UploadService } from 'app/services/upload.service';
import { SizePicture } from 'app/models2/commos/size-pircture';
import { CommentTypeDto } from 'app/models2/maintenance/comment-type';

@Component({
  selector: 'app-modal-types',
  templateUrl: './modal-types.component.html',
  styleUrls: ['./modal-types.component.scss'],
})
export class ModalTypesComponent implements OnInit, AfterViewInit {
  areaForm: UntypedFormGroup;
  itemForm: UntypedFormGroup;
  jobTitleForm: UntypedFormGroup;
  countryForm: UntypedFormGroup;
  regionForm: UntypedFormGroup;
  cityForm: UntypedFormGroup;
  epsForm: UntypedFormGroup;
  arlForm: UntypedFormGroup;
  equipmentTypeForm: UntypedFormGroup;
  controlPointerForm: UntypedFormGroup;
  commentForm: UntypedFormGroup;

  commentType: CommentTypeDto = null;
  
  public companyId = this.storage.get<number>('companyId');

  comboRegions: Array<Region>;
  comboCountry: Array<Country>;
  private urlUsersCombo: string = `${EndpointDictionary.User.USER_COMBO}`;

  public equipmentTypeLabel: string = null;
  public areaLabel: string = null;

  params: params[] = [];
  combosConfigResponsible: CombosConfiguration = {
    visibleField: 'name',
    selectionField: 'userId',
    urlCombo: this.urlUsersCombo,
    urlParams: this.params,
    label: 'Responsable',
  };

  combosConfigCommentsTypes: CombosConfiguration = {
    visibleField: 'name',
    selectionField: 'id',
    urlCombo: EndpointDictionary.WorkOrder.COMMENTS.TYPES,
    urlParams: [],
    label: 'Tipo de comentario',
  };

  public fileInput: fileInputParams = {
    typeFile: 'imagen',
    input: 'vista',
    label: 'foto',
    edit: true,
    style: {
      width: '100%',
      height: screen.width > 400 ? '300px' : '150px',
      border: '1px solid black',
    },
  };

  public fileInputPdfOrImg: fileInputParams = {
    typeFile: ['pdf', 'imagen', 'doc'],
    imageSrc:
      this.data.body?.attachmentUrl == null
        ? ''
        : `${EndpointDictionary.Base._BASE_URL_V2}${this.data.body.attachmentUrl}/${this.companyId}`,
    input: 'vista',
    label: 'Adjuntar archivo',
    edit: true,
    style: {
      width: '100%',
      height: screen.width > 400 ? '300px' : '150px',
    },
  };

  public file = null;
  public saveButtonNameCheckpoint: string = 'Guardar';
  public imageSrc: string;
  public sizePicture: SizePicture;

  constructor(
    public dialogRef: MatDialogRef<ModalTypesComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ModalTypes<any>,
    private formBuilder: UntypedFormBuilder,
    private http: HttpService,
    private message: MessageService,
    private storage: LocalStorageService,
    private uploadService: UploadService,
    private cdr: ChangeDetectorRef
  ) {
    this.areaForm = this.formBuilder.group({
      name: '',
      responsible: null,
      code: '',
      photo: '',
      description: '',
    });

    this.itemForm = this.formBuilder.group({
      code: '',
      itemName: '',
      costItem: '',
      unitMeasurement: '',
      description: '',
      minStock: 1,
      maxStock: null,
    });

    this.jobTitleForm = this.formBuilder.group({
      name: '',
    });

    this.equipmentTypeForm = this.formBuilder.group({
      name: '',
    });

    this.epsForm = this.formBuilder.group({
      name: '',
      contactNumber: '',
    });

    this.arlForm = this.formBuilder.group({
      name: '',
      contact: '',
    });

    this.controlPointerForm = this.formBuilder.group({
      name: '',
      description: '',
      photo: null,
    });

    this.commentForm = this.formBuilder.group({
      commentTypeId: null,
      comment: '',
      file: null,
    });
  }

  ngOnInit(): void {
    switch (this.data.name) {
      case 'punto de control':
        if (this.data.body && this.data.body.complete) {
          this.sizePicture = {
            width: '100%',
            height: screen.width > 400 ? '240px' : '150px',
            margin: '3px',
            visibility: 'hidde',
          };
          this.saveButtonNameCheckpoint = 'Cerrar';
          this.controlPointerForm.controls['name'].disable();
          this.controlPointerForm.controls['description'].disable();
          this.imageSrc = this.uploadService.getImagen(
            this.data.body.photo,
            this.companyId
          );
        }
        if (this.data.body && this.data.body.name) {
          this.controlPointerForm.controls['name'].disable();
        }
        for (let controls of Object.keys(this.controlPointerForm.controls)) {
          if (this.data.body[controls]) {
            this.controlPointerForm.controls[controls].setValue(
              this.data.body[controls].toString()
            );
          }
        }
        break;

      case 'comentario':
        if (this.data.body) {
          for (let controls of Object.keys(this.commentForm.controls)) {
            if (this.data.body[controls]) {
              this.commentForm.controls[controls].setValue(
                this.data.body[controls]
              );
            }
          }
        }
        if (this.data.body) {
          this.commentForm.controls.file.setValue(this.data.body.attachmentUrl);
        }
        break;
    }
  }

  ngAfterViewInit() {
  this.updateFileValidator();
  this.cdr.detectChanges();
}

  commentTypeData($event) {
    if (Array.isArray($event) && this.data?.body?.commentTypeId) {
      const found = $event.find(
        (item) => item.id === this.data.body.commentTypeId
      );
      if (found) {
        this.commentType = found;
        this.updateFileValidator();
      }
    }
  }

  onChangeCommentType($event) {
    this.commentType = $event;
    this.updateFileValidator();
  }

  ValueResponsable($event) {
    if ($event && $event > 0) {
      this.areaForm.controls.responsible.setValue($event);
    }
    //console.log("valueIDarea", $event)
  }

  handlerMinStock() {
    if (this.itemForm.controls.minStock.value < 0) {
      this.itemForm.controls.minStock.setValue(0);
    }
  }

  errorMessage() {}

  async save(form) {
    this.message.openLoading('Cargando', 'Creando dato');
    let url: string;
    switch (this.data.name) {
      case 'area':
        if (form.responsible == '' || !form.responsible) return;
        url = `${EndpointDictionary.Area.CRUD_AREA_DATA}`;
        this.areaForm.reset();
        break;

      case 'cargo':
        url = `${EndpointDictionary.Position.CRUD_POSITION_DATA}`;
        this.jobTitleForm.reset();
        break;

      case 'tipo de equipo':
        url = `${EndpointDictionary.EquipmentType.CRUD_EQUIPMENT_TYPE_DATA}`;
        this.equipmentTypeForm.reset();
        break;

      case 'eps':
        url = `${EndpointDictionary.EPS.CRUD_EPS_DATA}`;
        this.epsForm.reset();
        break;
      case 'arl':
        url = `${EndpointDictionary.ARL.CRUD_ARL_DATA}`;
        this.arlForm.reset();
        break;
      case 'item':
        url = `${EndpointDictionary.Item.CRUD_ITEM_DATA}`;
        this.itemForm.reset();
        break;

      case 'punto de control':
        form.photo = this.file;
        if (this.saveButtonNameCheckpoint === 'Cerrar') {
          form = null;
        }
        this.dialogRef.close(form);
        this.controlPointerForm.reset();
        this.message.closeLoading();
        return;

      case 'comentario':
        form.file = this.file;       
        this.dialogRef.close(form);
        this.commentForm.reset();
        this.message.closeLoading();
        return;

      default:
        this.message.Error('Error', 'No se tiene formulario asociado');
        return;
    }

    let res = await this.http.postDataBody<GenericResponse>(url, form);
    if (res) {
      this.message.SuccessToast(`${this.data.name}  agregado/a correctamente`);
    }

    this.message.closeLoading();
    this.dialogRef.close();
  }

  fileSave($event: UpdateData<File>) {
    if ($event.compressor) {
      this.file = $event.compressor;
    } else {
      this.file = $event.new;
    }
    this.commentForm.get('file').setValue(this.file);
    this.commentForm.get('file').markAsTouched(); // <--- Agrega esto
    this.updateFileValidator();
   // console.log(this.file);
  }

  updateFileValidator() {
    if (this.commentType && this.commentType.requiredFile) {
      this.commentForm.get('file').setValidators([Validators.required]);
      this.commentForm.get('comment').clearValidators();
    } else {
      this.commentForm.get('file').clearValidators();
      this.commentForm.get('comment').setValidators([Validators.required]);
    }
    this.commentForm.get('file').updateValueAndValidity();
    this.commentForm.get('comment').updateValueAndValidity();
  }
}
